import { useScrollAnimation } from "@/hooks/useScrollAnimation";

export default function About() {
  const ref = useScrollAnimation();

  return (
    <section
      id="about"
      style={{
        background: "#0f0f14",
        padding: "clamp(64px,10vw,120px) clamp(20px,5vw,80px)",
      }}
    >
      <div ref={ref} style={{ maxWidth: "1280px", margin: "0 auto" }}>
        {/* Section label */}
        <div
          className="section-label animate-on-scroll"
          style={{ marginBottom: "20px" }}
        >
          About The Fest
        </div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "clamp(40px,6vw,96px)",
            alignItems: "center",
          }}
          className="about-grid"
        >
          {/* Left — text */}
          <div>
            <h2
              className="display-heading animate-on-scroll"
              style={{
                fontSize: "clamp(2.5rem,6vw,4.5rem)",
                color: "#e8e8e8",
                marginBottom: "24px",
              }}
            >
              Indianapolis' Premier
              <br />
              <span style={{ color: "#cc0000" }}>Genre Film Festival</span>
            </h2>
            <p
              className="animate-on-scroll"
              style={{
                fontSize: "1rem",
                lineHeight: "1.75",
                color: "rgba(232,232,232,0.72)",
                marginBottom: "20px",
                transitionDelay: "100ms",
              }}
            >
              Midwest Fear Fest is a nonprofit film festival based in
              Indianapolis, Indiana. Founded by filmmakers in 2024, we focus on
              short films in the horror, thriller, and science fiction genres.
              Each fall, we bring together a community of genre fans, artists,
              and filmmakers to celebrate fearless filmmaking.
            </p>
            <p
              className="animate-on-scroll"
              style={{
                fontSize: "1rem",
                lineHeight: "1.75",
                color: "rgba(232,232,232,0.72)",
                transitionDelay: "150ms",
              }}
            >
              Our mission is to support independent filmmakers by providing a
              platform to share their work, connect with audiences, and grow
              their careers. While we welcome submissions from around the world,
              we are especially committed to uplifting local voices and
              strengthening the film community in Indianapolis. We believe in
              the power of film to entertain, challenge, and bring people
              together, and we aim to become the Midwest's premier destination
              for discovering and celebrating bold short films and the
              filmmakers who dare to make them.
            </p>

            <div
              className="animate-on-scroll"
              style={{
                marginTop: "32px",
                display: "flex",
                gap: "12px",
                flexWrap: "wrap",
                transitionDelay: "200ms",
              }}
            >
              <a
                href="https://kankanindy.com/events/midwestfearfest/"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-primary"
              >
                Get Tickets
              </a>
              <a
                href="#selections"
                className="btn-secondary"
                onClick={(e) => {
                  e.preventDefault();
                  document
                    .getElementById("selections")
                    ?.scrollIntoView({ behavior: "smooth" });
                }}
              >
                View Selections
              </a>
            </div>
          </div>

          {/* Right — camcorder image */}
          <div
            className="animate-on-scroll"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "flex-start",
              transitionDelay: "100ms",
            }}
          >
            <img
              src="/images/camcorder-orange.png"
              alt="Midwest Fear Fest"
              style={{
                width: "100%",
                maxWidth: "380px",
              }}
            />
          </div>
        </div>
      </div>

      <style>{`
        @media (max-width: 768px) {
          .about-grid {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </section>
  );
}
